import { __makeTemplateObject } from "tslib";
import { css } from '../../../foundation';
export var SnackbarStyle = function () {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
};
var templateObject_1;
